<template>
<v-container v-if="!isMobile">
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="pa-1">
      <v-select
          :items="boardName"
          value="boardName1A"
          label="Board Name"
          v-model="boardItem"
          @change="updateBoard"
          :item-text="
                        (boardName) => {
                          return (
                              boardName.boardName1A
                          );
                          }
                        "
          prepend-icon="mdi-integrated-circuit-chip"
          solo
          hide-details
        ></v-select>
      </div>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 15px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 15px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
    </v-app-bar>
  </nav>

 <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">
    <v-simple-table>
    <template v-slot:default>
      <thead>
       <tr>
           <th class="text-left" style="color:white;">
            DB Board
          </th>
          <th class="text-left" style="color:white;">
            Phase Label
          </th>
          <th class="text-left" style="color:white;">
            Location (Room by Google)
          </th>
          <th class="text-left" style="color:white;">
            Recent Consumption
          </th>
          <th class="text-left" style="color:white;">
            Total Power Query Period
          </th>
          <th class="text-left" style="color:white;">
            Load Type
          </th>
        </tr>
      </thead>
      <tbody @click="c_1A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[0].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[1].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[2].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[3].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[4].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[5].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[6].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[7].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[8].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[9].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[10].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[11].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[12].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[13].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[14].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[15].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[16].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[17].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[18].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[19].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[20].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[21].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[22].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{total[23].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[24].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[25].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[26].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[27].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[28].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[29].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[30].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{total[31].toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
   
  </v-col>
</v-row>
 </v-container>
</v-container>

<v-container v-else>
  <v-row>
      <div class="pa-1">
   <v-select
          :items="boardName"
          value="boardName1A"
          label="Board Name"
          v-model="boardItem"
          @change="updateBoard"
          :item-text="
                        (boardName) => {
                          return (
                              boardName.boardName1A
                          );
                          }
                        "
          prepend-icon="mdi-integrated-circuit-chip"
          solo
          hide-details
          style="font-size: 12px;"
        ></v-select>
   </div>
   <v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  > <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
   </v-container>
    </v-row>

     <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">
    <v-simple-table>
    <template v-slot:default>
      <thead>
       <tr>
           <th class="text-left" style="color:white;">
            DB Board
          </th>
          <th class="text-left" style="color:white;">
            Phase Label
          </th>
          <th class="text-left" style="color:white;">
            Location (Room by Google)
          </th>
          <th class="text-left" style="color:white;">
            Recent Consumption
          </th>
          <th class="text-left" style="color:white;">
            Total Power Query Period
          </th>
          <th class="text-left" style="color:white;">
            Load Type
          </th>
        </tr>
      </thead>
      <tbody @click="c_1A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1A.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1B.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1C.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1D.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1E.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1F.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1G.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_1H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName1H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel1H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location1H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value1H.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType1H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2A.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2B.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2C.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2D.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2E.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2F.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2G.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_2H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName2H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel2H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location2H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value2H.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType2H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3A.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3B.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3C.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3D.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3E.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3F.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3G.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_3H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{boardName3H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{phaseLabel3H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{location3H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{value3H.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{loadType3H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4A">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4A.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4A.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4A.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4A.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4B">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4B.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4B.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4B.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4B.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4C">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4C.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4C.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4C.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4C.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4D">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4D.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4D.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4D.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4D.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4E">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4E.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4E.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4E.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4E.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4F">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4F.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4F.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4F.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4F.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4G">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4G.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4G.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4G.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4G.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
      <tbody @click="c_4H">
        <tr>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{boardName4H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{phaseLabel4H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{location4H.slice(-1)[0]}}</td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4H.slice(-1)[0]}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{value4H.reduce((a, b) => a + b, 0).toFixed(2)}}<span style="font-size: 11px;">A</span></td>
          <td v-if="totalSensorAll.slice(-1)[0] == 4">{{loadType4H.slice(-1)[0].map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ')}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
   
  </v-col>
</v-row>
 </v-container>
</v-container>
</template>


<script>
import axios from "axios";
import moment from 'moment';
import router from "../../router";

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Energy',
          disabled: true,
          href: '',
        },
        {
          text: 'Usage By DB-MCB',
          disabled: true,
          href: '',
        },
      ],
      isMobile: true,
      values1: moment().subtract(24, "hour"),
      values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
    loading: true,
    board: [],
    total: [],
    totalSensorAll: [],

    boardName1A: [],
    phaseLabel1A: [],
    location1A: [],
    value1A: [],
    loadType1A: [],

    boardName1B: [],
    phaseLabel1B: [],
    location1B: [],
    value1B: [],
    loadType1B: [],

    boardName1C: [],
    phaseLabel1C: [],
    location1C: [],
    value1C: [],
    loadType1C: [],

    boardName1D: [],
    phaseLabel1D: [],
    location1D: [],
    value1D: [],
    loadType1D: [],

    boardName1E: [],
    phaseLabel1E: [],
    location1E: [],
    value1E: [],
    loadType1E: [],

    boardName1F: [],
    phaseLabel1F: [],
    location1F: [],
    value1F: [],
    loadType1F: [],

    boardName1G: [],
    phaseLabel1G: [],
    location1G: [],
    value1G: [],
    loadType1G: [],

    boardName1H: [],
    phaseLabel1H: [],
    location1H: [],
    value1H: [],
    loadType1H: [],

    boardName2A: [],
    phaseLabel2A: [],
    location2A: [],
    value2A: [],
    loadType2A: [],

    boardName2B: [],
    phaseLabel2B: [],
    location2B: [],
    value2B: [],
    loadType2B: [],

    boardName2C: [],
    phaseLabel2C: [],
    location2C: [],
    value2C: [],
    loadType2C: [],

    boardName2D: [],
    phaseLabel2D: [],
    location2D: [],
    value2D: [],
    loadType2D: [],

    boardName2E: [],
    phaseLabel2E: [],
    location2E: [],
    value2E: [],
    loadType2E: [],

    boardName2F: [],
    phaseLabel2F: [],
    location2F: [],
    value2F: [],
    loadType2F: [],

    boardName2G: [],
    phaseLabel2G: [],
    location2G: [],
    value2G: [],
    loadType2G: [],

    boardName2H: [],
    phaseLabel2H: [],
    location2H: [],
    value2H: [],
    loadType2H: [],

    boardName3A: [],
    phaseLabel3A: [],
    location3A: [],
    value3A: [],
    loadType3A: [],

    boardName3B: [],
    phaseLabel3B: [],
    location3B: [],
    value3B: [],
    loadType3B: [],

    boardName3C: [],
    phaseLabel3C: [],
    location3C: [],
    value3C: [],
    loadType3C: [],

    boardName3D: [],
    phaseLabel3D: [],
    location3D: [],
    value3D: [],
    loadType3D: [],

    boardName3E: [],
    phaseLabel3E: [],
    location3E: [],
    value3E: [],
    loadType3E: [],

    boardName3F: [],
    phaseLabel3F: [],
    location3F: [],
    value3F: [],
    loadType3F: [],

    boardName3G: [],
    phaseLabel3G: [],
    location3G: [],
    value3G: [],
    loadType3G: [],

    boardName3H: [],
    phaseLabel3H: [],
    location3H: [],
    value3H: [],
    loadType3H: [],

    boardName4A: [],
    phaseLabel4A: [],
    location4A: [],
    value4A: [],
    loadType4A: [],

    boardName4B: [],
    phaseLabel4B: [],
    location4B: [],
    value4B: [],
    loadType4B: [],

    boardName4C: [],
    phaseLabel4C: [],
    location4C: [],
    value4C: [],
    loadType4C: [],

    boardName4D: [],
    phaseLabel4D: [],
    location4D: [],
    value4D: [],
    loadType4D: [],

    boardName4E: [],
    phaseLabel4E: [],
    location4E: [],
    value4E: [],
    loadType4E: [],

    boardName4F: [],
    phaseLabel4F: [],
    location4F: [],
    value4F: [],
    loadType4F: [],

    boardName4G: [],
    phaseLabel4G: [],
    location4G: [],
    value4G: [],
    loadType4G: [],

    boardName4H: [],
    phaseLabel4H: [],
    location4H: [],
    value4H: [],
    loadType4H: [],
    tab: null,
    boardName: [],
    boardItem: []
  }),
  mounted() {
    this.loadsBoard();
    this.loadsTotal();
    this.loadsBoardName();
    this.intervalFetchData();
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    intervalFetchData: function () {
    setInterval(() => {    
      this.loadsBoard(),
      this.loadsTotal()
       }, 60000); 
    },
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
    c_1A() {
      router.push("/board/C_1A/" + this.boardItem);
    },
    c_1B() {
      router.push("/board/C_1B/" + this.boardItem);
    },
    c_1C() {
      router.push("/board/C_1C/" + this.boardItem);
    },
    c_1D() {
      router.push("/board/C_1D/" + this.boardItem);
    },
     c_1E() {
      router.push("/board/C_1E/" + this.boardItem);
    },
    c_1F() {
      router.push("/board/C_1F/" + this.boardItem);
    },
    c_1G() {
      router.push("/board/C_1G/" + this.boardItem);
    },
    c_1H() {
      router.push("/board/C_1H/" + this.boardItem);
    },
    c_2A() {
      router.push("/board/C_2A/" + this.boardItem);
    },
    c_2B() {
      router.push("/board/C_2B/" + this.boardItem);
    },
    c_2C() {
      router.push("/board/C_2C/" + this.boardItem);
    },
    c_2D() {
      router.push("/board/C_2D/" + this.boardItem);
    },
    c_2E() {
      router.push("/board/C_2E/" + this.boardItem);
    },
    c_2F() {
      router.push("/board/C_2F/" + this.boardItem);
    },
    c_2G() {
      router.push("/board/C_2G/" + this.boardItem);
    },
    c_2H() {
      router.push("/board/C_2H/" + this.boardItem);
    },
    c_3A() {
      router.push("/board/C_3A/" + this.boardItem);
    },
    c_3B() {
      router.push("/board/C_3B/" + this.boardItem);
    },
    c_3C() {
      router.push("/board/C_3C/" + this.boardItem);
    },
    c_3D() {
      router.push("/board/C_3D/" + this.boardItem);
    },
     c_3E() {
      router.push("/board/C_3E/" + this.boardItem);
    },
    c_3F() {
      router.push("/board/C_3F/" + this.boardItem);
    },
    c_3G() {
      router.push("/board/C_3G/" + this.boardItem);
    },
    c_3H() {
      router.push("/board/C_3H/" + this.boardItem);
    },
    c_4A() {
      router.push("/board/C_4A/" + this.boardItem);
    },
    c_4B() {
      router.push("/board/C_4B/" + this.boardItem);
    },
    c_4C() {
      router.push("/board/C_4C/" + this.boardItem);
    },
    c_4D() {
      router.push("/board/C_4D/" + this.boardItem);
    },
    c_4E() {
      router.push("/board/C_4E/" + this.boardItem);
    },
    c_4F() {
      router.push("/board/C_4F/" + this.boardItem);
    },
    c_4G() {
      router.push("/board/C_4G/" + this.boardItem);
    },
    c_4H() {
      router.push("/board/C_4H/" + this.boardItem);
    },
  formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsTotal: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/ecms/" + this.boardItem + "/total/" + this.values1.toDate() + '/'+ this.values2.toDate();
  axios.get(apiURL).then(res => {
    this.total = res.data.map((total) => total.total); 
  }).catch(error => {
    console.log(error)
  }).finally(() => this.loading = false);
},
  loadsBoard: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/ecms/" + this.boardItem + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
  axios.get(apiURL).then(res => {
    this.board = res.data;
    this.totalSensorAll = res.data.map((totalSensor) => totalSensor.tags.totalSensor);
    this.boardName1A = res.data.map((boardName) => boardName.fields.C_1A.boardName);
    this.phaseLabel1A = res.data.map((phaseLabel) => phaseLabel.fields.C_1A.ryb.label);
    this.location1A = res.data.map((location) => location.fields.C_1A.location.location);
    this.value1A = res.data.map((value) => value.fields.C_1A.value);
    this.loadType1A = res.data.map((loadType) => loadType.fields.C_1A.loadType);

    this.boardName1B = res.data.map((boardName) => boardName.fields.C_1B.boardName);
    this.phaseLabel1B = res.data.map((phaseLabel) => phaseLabel.fields.C_1B.ryb.label);
    this.location1B = res.data.map((location) => location.fields.C_1B.location.location);
    this.value1B = res.data.map((value) => value.fields.C_1B.value);
    this.loadType1B = res.data.map((loadType) => loadType.fields.C_1B.loadType);

    this.boardName1C = res.data.map((boardName) => boardName.fields.C_1C.boardName);
    this.phaseLabel1C = res.data.map((phaseLabel) => phaseLabel.fields.C_1C.ryb.label);
    this.location1C = res.data.map((location) => location.fields.C_1C.location.location);
    this.value1C = res.data.map((value) => value.fields.C_1C.value);
    this.loadType1C = res.data.map((loadType) => loadType.fields.C_1C.loadType);

    this.boardName1D = res.data.map((boardName) => boardName.fields.C_1D.boardName);
    this.phaseLabel1D = res.data.map((phaseLabel) => phaseLabel.fields.C_1D.ryb.label);
    this.location1D = res.data.map((location) => location.fields.C_1D.location.location);
    this.value1D = res.data.map((value) => value.fields.C_1D.value);
    this.loadType1D = res.data.map((loadType) => loadType.fields.C_1D.loadType);

    this.boardName1E = res.data.map((boardName) => boardName.fields.C_1E.boardName);
    this.phaseLabel1E = res.data.map((phaseLabel) => phaseLabel.fields.C_1E.ryb.label);
    this.location1E = res.data.map((location) => location.fields.C_1E.location.location);
    this.value1E = res.data.map((value) => value.fields.C_1E.value);
    this.loadType1E = res.data.map((loadType) => loadType.fields.C_1E.loadType);

    this.boardName1F = res.data.map((boardName) => boardName.fields.C_1F.boardName);
    this.phaseLabel1F = res.data.map((phaseLabel) => phaseLabel.fields.C_1F.ryb.label);
    this.location1F = res.data.map((location) => location.fields.C_1F.location.location);
    this.value1F = res.data.map((value) => value.fields.C_1F.value);
    this.loadType1F = res.data.map((loadType) => loadType.fields.C_1F.loadType);

    this.boardName1G = res.data.map((boardName) => boardName.fields.C_1G.boardName);
    this.phaseLabel1G = res.data.map((phaseLabel) => phaseLabel.fields.C_1G.ryb.label);
    this.location1G = res.data.map((location) => location.fields.C_1G.location.location);
    this.value1G = res.data.map((value) => value.fields.C_1G.value);
    this.loadType1G = res.data.map((loadType) => loadType.fields.C_1G.loadType);

    this.boardName1H = res.data.map((boardName) => boardName.fields.C_1H.boardName);
    this.phaseLabel1H = res.data.map((phaseLabel) => phaseLabel.fields.C_1H.ryb.label);
    this.location1H = res.data.map((location) => location.fields.C_1H.location.location);
    this.value1H = res.data.map((value) => value.fields.C_1H.value);
    this.loadType1H = res.data.map((loadType) => loadType.fields.C_1H.loadType);

    this.boardName2A = res.data.map((boardName) => boardName.fields.C_2A.boardName);
    this.phaseLabel2A = res.data.map((phaseLabel) => phaseLabel.fields.C_2A.ryb.label);
    this.location2A = res.data.map((location) => location.fields.C_2A.location.location);
    this.value2A = res.data.map((value) => value.fields.C_2A.value);
    this.loadType2A = res.data.map((loadType) => loadType.fields.C_2A.loadType);

    this.boardName2B = res.data.map((boardName) => boardName.fields.C_2B.boardName);
    this.phaseLabel2B = res.data.map((phaseLabel) => phaseLabel.fields.C_2B.ryb.label);
    this.location2B = res.data.map((location) => location.fields.C_2B.location.location);
    this.value2B = res.data.map((value) => value.fields.C_2B.value);
    this.loadType2B = res.data.map((loadType) => loadType.fields.C_2B.loadType);

    this.boardName2C = res.data.map((boardName) => boardName.fields.C_2C.boardName);
    this.phaseLabel2C = res.data.map((phaseLabel) => phaseLabel.fields.C_2C.ryb.label);
    this.location2C = res.data.map((location) => location.fields.C_2C.location.location);
    this.value2C = res.data.map((value) => value.fields.C_2C.value);
    this.loadType2C = res.data.map((loadType) => loadType.fields.C_2C.loadType);

    this.boardName2D = res.data.map((boardName) => boardName.fields.C_2D.boardName);
    this.phaseLabel2D = res.data.map((phaseLabel) => phaseLabel.fields.C_2D.ryb.label);
    this.location2D = res.data.map((location) => location.fields.C_2D.location.location);
    this.value2D = res.data.map((value) => value.fields.C_2D.value);
    this.loadType2D = res.data.map((loadType) => loadType.fields.C_2D.loadType);

    this.boardName2E = res.data.map((boardName) => boardName.fields.C_2E.boardName);
    this.phaseLabel2E = res.data.map((phaseLabel) => phaseLabel.fields.C_2E.ryb.label);
    this.location2E = res.data.map((location) => location.fields.C_2E.location.location);
    this.value2E = res.data.map((value) => value.fields.C_2E.value);
    this.loadType2E = res.data.map((loadType) => loadType.fields.C_2E.loadType);

    this.boardName2F = res.data.map((boardName) => boardName.fields.C_2F.boardName);
    this.phaseLabel2F = res.data.map((phaseLabel) => phaseLabel.fields.C_2F.ryb.label);
    this.location2F = res.data.map((location) => location.fields.C_2F.location.location);
    this.value2F = res.data.map((value) => value.fields.C_2F.value);
    this.loadType2F = res.data.map((loadType) => loadType.fields.C_2F.loadType);

    this.boardName2G = res.data.map((boardName) => boardName.fields.C_2G.boardName);
    this.phaseLabel2G = res.data.map((phaseLabel) => phaseLabel.fields.C_2G.ryb.label);
    this.location2G = res.data.map((location) => location.fields.C_2G.location.location);
    this.value2G = res.data.map((value) => value.fields.C_2G.value);
    this.loadType2G = res.data.map((loadType) => loadType.fields.C_2G.loadType);

    this.boardName2H = res.data.map((boardName) => boardName.fields.C_2H.boardName);
    this.phaseLabel2H = res.data.map((phaseLabel) => phaseLabel.fields.C_2H.ryb.label);
    this.location2H = res.data.map((location) => location.fields.C_2H.location.location);
    this.value2H = res.data.map((value) => value.fields.C_2H.value);
    this.loadType2H = res.data.map((loadType) => loadType.fields.C_2H.loadType);

    this.boardName3A = res.data.map((boardName) => boardName.fields.C_3A.boardName);
    this.phaseLabel3A = res.data.map((phaseLabel) => phaseLabel.fields.C_3A.ryb.label);
    this.location3A = res.data.map((location) => location.fields.C_3A.location.location);
    this.value3A = res.data.map((value) => value.fields.C_3A.value);
    this.loadType3A = res.data.map((loadType) => loadType.fields.C_3A.loadType);

    this.boardName3B = res.data.map((boardName) => boardName.fields.C_3B.boardName);
    this.phaseLabel3B = res.data.map((phaseLabel) => phaseLabel.fields.C_3B.ryb.label);
    this.location3B = res.data.map((location) => location.fields.C_3B.location.location);
    this.value3B = res.data.map((value) => value.fields.C_3B.value);
    this.loadType3B = res.data.map((loadType) => loadType.fields.C_3B.loadType);

    this.boardName3C = res.data.map((boardName) => boardName.fields.C_3C.boardName);
    this.phaseLabel3C = res.data.map((phaseLabel) => phaseLabel.fields.C_3C.ryb.label);
    this.location3C = res.data.map((location) => location.fields.C_3C.location.location);
    this.value3C = res.data.map((value) => value.fields.C_3C.value);
    this.loadType3C = res.data.map((loadType) => loadType.fields.C_3C.loadType);

    this.boardName3D = res.data.map((boardName) => boardName.fields.C_3D.boardName);
    this.phaseLabel3D = res.data.map((phaseLabel) => phaseLabel.fields.C_3D.ryb.label);
    this.location3D = res.data.map((location) => location.fields.C_3D.location.location);
    this.value3D = res.data.map((value) => value.fields.C_3D.value);
    this.loadType3D = res.data.map((loadType) => loadType.fields.C_3D.loadType);

    this.boardName3E = res.data.map((boardName) => boardName.fields.C_3E.boardName);
    this.phaseLabel3E = res.data.map((phaseLabel) => phaseLabel.fields.C_3E.ryb.label);
    this.location3E = res.data.map((location) => location.fields.C_3E.location.location);
    this.value3E = res.data.map((value) => value.fields.C_3E.value);
    this.loadType3E = res.data.map((loadType) => loadType.fields.C_3E.loadType);

    this.boardName3F = res.data.map((boardName) => boardName.fields.C_3F.boardName);
    this.phaseLabel3F = res.data.map((phaseLabel) => phaseLabel.fields.C_3F.ryb.label);
    this.location3F = res.data.map((location) => location.fields.C_3F.location.location);
    this.value3F = res.data.map((value) => value.fields.C_3F.value);
    this.loadType3F = res.data.map((loadType) => loadType.fields.C_3F.loadType);

    this.boardName3G = res.data.map((boardName) => boardName.fields.C_3G.boardName);
    this.phaseLabel3G = res.data.map((phaseLabel) => phaseLabel.fields.C_3G.ryb.label);
    this.location3G = res.data.map((location) => location.fields.C_3G.location.location);
    this.value3G = res.data.map((value) => value.fields.C_3G.value);
    this.loadType3G = res.data.map((loadType) => loadType.fields.C_3G.loadType);

    this.boardName3H = res.data.map((boardName) => boardName.fields.C_3H.boardName);
    this.phaseLabel3H = res.data.map((phaseLabel) => phaseLabel.fields.C_3H.ryb.label);
    this.location3H = res.data.map((location) => location.fields.C_3H.location.location);
    this.value3H = res.data.map((value) => value.fields.C_3H.value);
    this.loadType3H = res.data.map((loadType) => loadType.fields.C_3H.loadType);

    this.boardName4A = res.data.map((boardName) => boardName.fields.C_4A.boardName);
    this.phaseLabel4A = res.data.map((phaseLabel) => phaseLabel.fields.C_4A.ryb.label);
    this.location4A = res.data.map((location) => location.fields.C_4A.location.location);
    this.value4A = res.data.map((value) => value.fields.C_4A.value);
    this.loadType4A = res.data.map((loadType) => loadType.fields.C_4A.loadType);

    this.boardName4B = res.data.map((boardName) => boardName.fields.C_4B.boardName);
    this.phaseLabel4B = res.data.map((phaseLabel) => phaseLabel.fields.C_4B.ryb.label);
    this.location4B = res.data.map((location) => location.fields.C_4B.location.location);
    this.value4B = res.data.map((value) => value.fields.C_4B.value);
    this.loadType4B = res.data.map((loadType) => loadType.fields.C_4B.loadType);

    this.boardName4C = res.data.map((boardName) => boardName.fields.C_4C.boardName);
    this.phaseLabel4C = res.data.map((phaseLabel) => phaseLabel.fields.C_4C.ryb.label);
    this.location4C = res.data.map((location) => location.fields.C_4C.location.location);
    this.value4C = res.data.map((value) => value.fields.C_4C.value);
    this.loadType4C = res.data.map((loadType) => loadType.fields.C_4C.loadType);

    this.boardName4D = res.data.map((boardName) => boardName.fields.C_4D.boardName);
    this.phaseLabel4D = res.data.map((phaseLabel) => phaseLabel.fields.C_4D.ryb.label);
    this.location4D = res.data.map((location) => location.fields.C_4D.location.location);
    this.value4D = res.data.map((value) => value.fields.C_4D.value);
    this.loadType4D = res.data.map((loadType) => loadType.fields.C_4D.loadType);

    this.boardName4E = res.data.map((boardName) => boardName.fields.C_4E.boardName);
    this.phaseLabel4E = res.data.map((phaseLabel) => phaseLabel.fields.C_4E.ryb.label);
    this.location4E = res.data.map((location) => location.fields.C_4E.location.location);
    this.value4E = res.data.map((value) => value.fields.C_4E.value);
    this.loadType4E = res.data.map((loadType) => loadType.fields.C_4E.loadType);

    this.boardName4F = res.data.map((boardName) => boardName.fields.C_4F.boardName);
    this.phaseLabel4F = res.data.map((phaseLabel) => phaseLabel.fields.C_4F.ryb.label);
    this.location4F = res.data.map((location) => location.fields.C_4F.location.location);
    this.value4F = res.data.map((value) => value.fields.C_4F.value);
    this.loadType4F = res.data.map((loadType) => loadType.fields.C_4F.loadType);

    this.boardName4G = res.data.map((boardName) => boardName.fields.C_4G.boardName);
    this.phaseLabel4G = res.data.map((phaseLabel) => phaseLabel.fields.C_4G.ryb.label);
    this.location4G = res.data.map((location) => location.fields.C_4G.location.location);
    this.value4G = res.data.map((value) => value.fields.C_4G.value);
    this.loadType4G = res.data.map((loadType) => loadType.fields.C_4G.loadType);

    this.boardName4H = res.data.map((boardName) => boardName.fields.C_4H.boardName);
    this.phaseLabel4H = res.data.map((phaseLabel) => phaseLabel.fields.C_4H.ryb.label);
    this.location4H = res.data.map((location) => location.fields.C_4H.location.location);
    this.value4H = res.data.map((value) => value.fields.C_4H.value);
    this.loadType4H = res.data.map((loadType) => loadType.fields.C_4H.loadType);
  }).catch(error => {
    console.log(error)
  });
},
loadsBoardName: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/board";
      axios.get(apiURL).then(res => {
      this.boardName = res.data;
      this.boardItem = this.boardName[0].boardName1A;
      this.loadsBoard();
      this.loadsTotal();
      }).catch(error => {
      console.log(error)
      });
},
updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsBoard();
      this.loadsTotal();
      this.loading = true;
    },

updateBoard(){
      this.loadsBoard();
      this.loadsTotal();
      this.loading = true;
    },

  },
beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
}
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>